import { RcFile } from "antd/es/upload";

export const urlToRcFile = async (url: string, isPayload?:boolean, fileName = "image.jpg") => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type }) as RcFile;
  file.uid = "-1"; // Ensure unique ID for Ant Design Upload
  return isPayload ? file : { ...file, url };
};